import React from 'react';
import { Card } from '../components/UI/Card';
import { Button } from '../components/UI/Button';
import { Mail, Handshake } from 'lucide-react';
export const Partners = () => {
  const partners = [{
    name: 'Not A Flower Girl Ltd.',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fzw81HLpEsCdXEuQ5n5hSj/2.png',
    description: 'Leading creative agency supporting cultural initiatives.'
  }, {
    name: 'Brooks & Brown',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/o3ypkjhB7kJ2Wy5Za65rMU/3.png',
    description: 'Consulting firm specializing in community development.'
  }, {
    name: 'Andre MORE Ideation',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rAwr3ugU2e9fekWEX2roAw/4.png',
    description: 'Innovation hub for emerging entrepreneurs.'
  }, {
    name: 'The Work Haven',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qnj3kw6MbAbRKB8AWygyGk/5.png',
    description: 'Co-working space and community for professionals.'
  }];
  return <div className="pt-20" data-id="element-3495">
      <section className="py-16 bg-secondary/5" data-id="element-3496">
        <div className="container mx-auto px-4" data-id="element-3497">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-3498">
            Our Partners
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-3499">
            We collaborate with forward-thinking organizations to create more
            opportunities, resources, and connections for our community members.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-3500">
        <div className="container mx-auto px-4" data-id="element-3501">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16" data-id="element-3502">
            {partners.map((partner, index) => <Card key={index} className="p-6 flex flex-col items-center" data-id="element-3503">
                <div className="h-24 mb-6 flex items-center justify-center" data-id="element-3504">
                  <img src={partner.logo} alt={partner.name} className="max-h-full max-w-full object-contain" data-id="element-3505" />
                </div>
                <h3 className="text-xl font-bold text-secondary-dark mb-2 text-center" data-id="element-3506">
                  {partner.name}
                </h3>
                <p className="text-secondary text-center mb-4" data-id="element-3507">
                  {partner.description}
                </p>
              </Card>)}
          </div>
          <div className="bg-secondary/5 rounded-lg p-8 border border-gray-200" data-id="element-3508">
            <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-3509">
              <div className="md:w-2/3" data-id="element-3510">
                <h2 className="text-2xl font-bold text-secondary-dark mb-4" data-id="element-3511">
                  Become a Partner
                </h2>
                <p className="text-secondary mb-6" data-id="element-3512">
                  Partner with The Networking Salon to co-create events, share
                  resources, and connect with our global community of
                  professionals and changemakers. We're always looking for
                  organizations that align with our mission of building
                  meaningful connections and creating opportunities.
                </p>
                <div className="flex flex-wrap gap-4" data-id="element-3513">
                  <Button data-id="element-3514">
                    <Mail className="mr-2" size={18} data-id="element-3515" />
                    Contact Us
                  </Button>
                  <Button variant="outline" data-id="element-3516">
                    <Handshake className="mr-2" size={18} data-id="element-3517" />
                    Partnership Guide
                  </Button>
                </div>
              </div>
              <div className="md:w-1/3 border-2 border-gray-300 rounded-lg p-4 bg-white" data-id="element-3518">
                <h3 className="text-lg font-bold text-secondary-dark mb-2" data-id="element-3519">
                  Partnership Benefits
                </h3>
                <ul className="space-y-2" data-id="element-3520">
                  <li className="flex items-start" data-id="element-3521">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-3522"></div>
                    <span data-id="element-3523">Access to our global network</span>
                  </li>
                  <li className="flex items-start" data-id="element-3524">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-3525"></div>
                    <span data-id="element-3526">Co-branded events and content</span>
                  </li>
                  <li className="flex items-start" data-id="element-3527">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-3528"></div>
                    <span data-id="element-3529">Visibility with our community</span>
                  </li>
                  <li className="flex items-start" data-id="element-3530">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-3531"></div>
                    <span data-id="element-3532">Resource sharing opportunities</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};